import React, { useEffect, useMemo, useState } from 'react'
import styles from "./Templates.module.css"
import { Link, useLocation, useParams } from 'react-router-dom'
import Templatepage1 from './Templatepage1';
import Templatepage2 from './Templatepage2';
import TemplateHeader from './TemplateHeader';
import Templatepage3 from './Templatepage3';
import Templatefooter from './Templatefooter';
import Templateadmin from './Templateadmin';
import { getTemplatesByCategory } from '../../dashboardapi';
import Loading from '../../components/Loading';
import { set } from 'lodash';

const Templates = () => {
    const { subcat, singletemp } = useParams();
    const [currentTemplate, setCurrentTemplate] = useState({ cat: "" })
    const [List, setList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    function ScrollToTop() {
        const { pathname } = useLocation();

        useEffect(() => {
            window.scrollTo(0, 0);
        }, [pathname]);

        return null;
    }

    const categories = useMemo(() => ({
        "journal_articles": {
            title: "Journal articles",
            desc: "Professional academic templates for research papers and scholarly publications",
            hash: "journalarticles",
            list: []
        },
        "Books": {
            title: "Books",
            desc: "Premium templates for novels, textbooks, and professional publications",
            hash: "books",
            list: []
        },
        "Calendars": {
            title: "Calendars",
            desc: "Beautifully designed templates for yearly, monthly, and weekly planners",
            hash: "calendars",
            list: []
        },
        "Formal_letters": {
            title: "Formal letters",
            desc: "Professional correspondence templates for business and official communications",
            hash: "formalletters",
            list: []
        },
        "Assignments": {
            title: "Assignments",
            desc: "Structured templates for academic projects and homework submissions",
            hash: "assignments",
            list: []
        },
        "Newsletters": {
            title: "Newsletters",
            desc: "Engaging templates for company updates, community news, and marketing communications",
            hash: "newsletters",
            list: []
        },
        "Presentations": {
            title: "Presentations",
            desc: "Professional slide decks for business meetings, academic talks, and conferences",
            hash: "presentations",
            list: []
        },
        "Reports": {
            title: "Reports",
            desc: "Comprehensive templates for business analysis, academic research, and project documentation",
            hash: "reports",
            list: []
        }
    }), []);

    useEffect(() => {
        handleTemplate(categories, subcat)
    }, [subcat, categories])

    const handleTemplate = async (categories, subcat) => {
        if (!subcat) {
            setIsLoading(false);
            return;
        }  // no subcat, do nothing
        setIsLoading(true);
        try {
            const catdetail = await getTemplatesByCategory(subcat);

            if (catdetail.data) {
                console.log(catdetail.data);

                categories[subcat].list.push(catdetail.data.data)
            } else {
                console.log("No data to show");
            }

            // // Find the category object with matching hash
            const matchedCategory = Object.entries(categories).find(cat => cat[0] === subcat);
            if (matchedCategory) {
                setCurrentTemplate({ cat: matchedCategory });
                console.log(currentTemplate?.cat?.[1]);
            } else {
                // Optional: handle case when no match found
                setCurrentTemplate({ cat: null });
            }
        } catch (error) {
            console.log(error);
            setCurrentTemplate({ cat: null });
        }
        finally {
            setIsLoading(false);
        }
    };


    console.log(currentTemplate);


    return (
        <div className={styles.template_page_outer}>
            <div className={styles.indivtemplateouter}>
                <ScrollToTop />
                <TemplateHeader />
                <div className={styles.template_page_out}>
                    {isLoading ? (
                        <div style={{ marginBottom: "20vw" }}>
                            <Loading loading={isLoading} />
                        </div>
                    ) : !subcat ? (
                        <div className={styles.template_cat_outer}>
                            <Templatepage1 categories={categories} />
                        </div>
                    ) : (
                        <div className={styles.template_cat_outer}>
                            <Templatepage2 list={currentTemplate?.cat?.[1]} />
                        </div>
                    )}
                </div>
            </div>
            <div className={styles.footer_outer}>
                <Templatefooter />
            </div>
        </div>
    )
}

export default Templates;


//  Templates.js
//  ├─ TemplateHeader
//  ├─ Conditional Rendering:
//  │    ├─ Templatepage1  (if subcat not selected)
//  │    └─ Templatepage2  (if subcat is selected)
//  └─ Templatefooter